const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.68,245.86c-90.43-52.21-236.58-52.21-326.43,0S-3.12,382.73,87.31,435s236.59,52.21,326.44,0S503.12,298.08,412.68,245.86Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "450.49 283.82 389.85 248.8 339.6 278 400.25 313.01 450.49 283.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,341.26l146.66,84.67a15.92,15.92,0,0,0,14.46,0l145.71-84.68c2-1.15,3-2.67,3-4.18s-1-3-3-4.2L256.74,248.2a16,16,0,0,0-14.47,0L96.55,332.88c-2,1.15-3,2.67-3,4.19S94.6,340.1,96.61,341.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.43,409.94c-14.12-8.15-36.94-8.15-51,0s-14,21.37.16,29.53,36.95,8.15,51,0S394.55,418.09,380.43,409.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.47,403.81c-14.12-8.16-36.94-8.16-51,0s-14,21.37.16,29.52,37,8.15,51,0S177.59,412,163.47,403.81Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "342.77 241.76 342.67 276.78 399.85 309.79 399.95 274.77 342.77 241.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 274.43 346.84 248.84 395.85 277.13 395.78 302.72 346.77 274.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 274.43 346.84 248.84 395.85 277.13 395.78 302.72 346.77 274.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 274.43 346.84 248.84 395.85 277.13 395.78 302.72 346.77 274.43",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 274.77 399.85 309.79 447.22 282.26 447.32 247.24 399.95 274.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 274.77 399.85 309.79 447.22 282.26 447.32 247.24 399.95 274.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 274.77 399.85 309.79 447.22 282.26 447.32 247.24 399.95 274.77",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 247.24 390.14 214.23 342.77 241.76 399.95 274.77 447.32 247.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 247.24 390.14 214.23 342.77 241.76 399.95 274.77 447.32 247.24",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.65 271.27 380.76 273.06 380.73 276.29 377.63 274.5 377.65 271.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.73 276.29 380.71 290.1 377.6 288.31 377.63 274.5 380.73 276.29",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.34 290.49 386.3 293.33 383.19 291.54 383.23 288.7 386.34 290.49",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.24 274.5 386.35 276.29 386.34 290.49 383.23 288.7 383.24 274.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.83 277.73 391.94 279.52 391.92 284.09 388.81 282.3 388.83 277.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 284.09 391.89 296.55 388.78 294.76 388.81 282.3 391.92 284.09",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.77 201.19 342.67 236.21 399.85 269.22 399.95 234.2 342.77 201.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 233.85 346.84 208.26 395.85 236.56 395.78 262.14 346.77 233.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 233.85 346.84 208.26 395.85 236.56 395.78 262.14 346.77 233.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 233.85 346.84 208.26 395.85 236.56 395.78 262.14 346.77 233.85",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 234.2 399.85 269.22 447.22 241.69 447.32 206.67 399.95 234.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 234.2 399.85 269.22 447.22 241.69 447.32 206.67 399.95 234.2",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 234.2 399.85 269.22 447.22 241.69 447.32 206.67 399.95 234.2",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 206.67 390.14 173.66 342.77 201.19 399.95 234.2 447.32 206.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 206.67 390.14 173.66 342.77 201.19 399.95 234.2 447.32 206.67",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.65 230.7 380.76 232.49 380.73 244.76 377.63 242.97 377.65 230.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.73 244.76 380.71 249.53 377.6 247.73 377.63 242.97 380.73 244.76",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.34 245.4 386.3 252.75 383.19 250.96 383.23 243.61 386.34 245.4",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.24 233.93 386.35 235.72 386.34 245.4 383.23 243.61 383.24 233.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.83 237.15 391.94 238.94 391.92 249.08 388.81 247.28 388.83 237.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 249.08 391.89 255.98 388.78 254.19 388.81 247.28 391.92 249.08",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.77 160.61 342.67 195.64 399.85 228.65 399.95 193.62 342.77 160.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 193.28 346.84 167.69 395.85 195.98 395.78 221.57 346.77 193.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 193.28 346.84 167.69 395.85 195.98 395.78 221.57 346.77 193.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 193.28 346.84 167.69 395.85 195.98 395.78 221.57 346.77 193.28",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 193.62 399.85 228.65 447.22 201.12 447.32 166.1 399.95 193.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 193.62 399.85 228.65 447.22 201.12 447.32 166.1 399.95 193.62",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 193.62 399.85 228.65 447.22 201.12 447.32 166.1 399.95 193.62",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 166.1 390.14 133.09 342.77 160.61 399.95 193.62 447.32 166.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 166.1 390.14 133.09 342.77 160.61 399.95 193.62 447.32 166.1",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.65 190.12 380.76 191.92 380.73 196.17 377.63 194.38 377.65 190.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.73 196.17 380.71 208.95 377.6 207.16 377.63 194.38 380.73 196.17",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.34 206.28 386.3 212.18 383.19 210.39 383.23 204.48 386.34 206.28",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.24 193.35 386.35 195.15 386.34 206.28 383.23 204.48 383.24 193.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.83 196.58 391.94 198.37 391.92 206.42 388.81 204.62 388.83 196.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 206.42 391.89 215.41 388.78 213.61 388.81 204.62 391.92 206.42",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.77 120.04 342.67 155.06 399.85 188.07 399.95 153.05 342.77 120.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 152.7 346.84 127.12 395.85 155.41 395.78 181 346.77 152.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 152.7 346.84 127.12 395.85 155.41 395.78 181 346.77 152.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 152.7 346.84 127.12 395.85 155.41 395.78 181 346.77 152.7",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 153.05 399.85 188.07 447.22 160.54 447.32 125.52 399.95 153.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 153.05 399.85 188.07 447.22 160.54 447.32 125.52 399.95 153.05",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 153.05 399.85 188.07 447.22 160.54 447.32 125.52 399.95 153.05",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 125.52 390.14 92.51 342.77 120.04 399.95 153.05 447.32 125.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.32 125.52 390.14 92.51 342.77 120.04 399.95 153.05 447.32 125.52",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.65 149.55 380.76 151.34 380.73 159.86 377.63 158.06 377.65 149.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.73 159.86 380.71 168.38 377.6 166.59 377.63 158.06 380.73 159.86",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.34 158 386.3 171.61 383.19 169.81 383.23 156.21 386.34 158",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.24 152.78 386.35 154.57 386.34 158 383.23 156.21 383.24 152.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.83 156 391.94 157.8 391.92 163.76 388.81 161.97 388.83 156",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 163.76 391.89 174.83 388.78 173.04 388.81 161.97 391.92 163.76",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,155.16l.1,0-.1,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,148.76a14.57,14.57,0,0,0-6.61-11.45c-1.82-1.06-3.47-1.16-4.68-.49h0l-3.44,2h0c1.21-.67,2.85-.56,4.67.49A14.57,14.57,0,0,1,364,150.77c0,2-.7,3.44-1.81,4.16l3.27-1.88.1-.05.05,0h0C366.71,152.25,367.42,150.81,367.43,148.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.43,148.76a14.57,14.57,0,0,0-6.61-11.45c-1.82-1.06-3.47-1.16-4.68-.49h0l-3.44,2h0c1.21-.67,2.85-.56,4.67.49A14.57,14.57,0,0,1,364,150.77c0,2-.7,3.44-1.81,4.16l3.27-1.88.1-.05.05,0h0C366.71,152.25,367.42,150.81,367.43,148.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,150.77a14.57,14.57,0,0,0-6.62-11.46c-1.82-1.05-3.46-1.16-4.67-.49s-2,2.17-2,4.29a14.6,14.6,0,0,0,6.61,11.45,4.86,4.86,0,0,0,4.44.59l.1,0,.31-.18C363.26,154.21,364,152.78,364,150.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,150.77a14.57,14.57,0,0,0-6.62-11.46c-1.82-1.05-3.46-1.16-4.67-.49s-2,2.17-2,4.29a14.6,14.6,0,0,0,6.61,11.45,4.86,4.86,0,0,0,4.44.59l.1,0,.31-.18C363.26,154.21,364,152.78,364,150.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,150.16a10.37,10.37,0,0,0-4.71-8.16,3.35,3.35,0,0,0-3.33-.35h0l-2.45,1.42h0a3.35,3.35,0,0,1,3.32.34,10.42,10.42,0,0,1,4.72,8.16,3.39,3.39,0,0,1-1.29,3l2.33-1.34.07,0,0,0h0A3.35,3.35,0,0,0,360.84,150.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,150.16a10.37,10.37,0,0,0-4.71-8.16,3.35,3.35,0,0,0-3.33-.35h0l-2.45,1.42h0a3.35,3.35,0,0,1,3.32.34,10.42,10.42,0,0,1,4.72,8.16,3.39,3.39,0,0,1-1.29,3l2.33-1.34.07,0,0,0h0A3.35,3.35,0,0,0,360.84,150.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.37,151.58a10.42,10.42,0,0,0-4.72-8.16,3.35,3.35,0,0,0-3.32-.34,3.29,3.29,0,0,0-1.42,3,10.38,10.38,0,0,0,4.71,8.15,3.44,3.44,0,0,0,3.16.43l.08,0,.22-.13A3.39,3.39,0,0,0,358.37,151.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.37,151.58a10.42,10.42,0,0,0-4.72-8.16,3.35,3.35,0,0,0-3.32-.34,3.29,3.29,0,0,0-1.42,3,10.38,10.38,0,0,0,4.71,8.15,3.44,3.44,0,0,0,3.16.43l.08,0,.22-.13A3.39,3.39,0,0,0,358.37,151.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,146.73a1.29,1.29,0,0,0-1.29-.13l-.14.11-.06,0a56.82,56.82,0,0,0-6.33,4.18,116.72,116.72,0,0,1-14.77,9.34c-6.42,3.52-12.85,5.15-18.62,4.7-6.6-.51-12.5-3.92-15.39-8.88-2.28-3.92-3-9.09-2.28-15.78.26-2.37.68-4.81,1.09-7.16a89.86,89.86,0,0,0,1.39-10.67c.28-5.36-.41-12.93-5.25-18.58a18.73,18.73,0,0,0-10.48-6.16c-8.36-1.69-16.46,2.5-23.4,6.57l2.58,4.42c6.41-3.76,13.21-7.31,19.8-6a13.71,13.71,0,0,1,7.62,4.47c3.73,4.38,4.25,10.57,4,15a82,82,0,0,1-1.33,10.06c-.41,2.43-.85,4.94-1.13,7.46-.87,7.83.09,14,2.95,18.92,3.72,6.4,11.16,10.77,19.42,11.41.75.06,1.52.09,2.29.09a40.37,40.37,0,0,0,19.18-5.4A123.62,123.62,0,0,0,348.49,155a52,52,0,0,1,5.75-3.8l.21-.11h0l.09,0a1.33,1.33,0,0,0,.5-1.15A4,4,0,0,0,353.21,146.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.46,103.06a4.37,4.37,0,0,0-1.77-2l-1.17.59a3.22,3.22,0,0,1,1.76,4.75l.08,0,1.25-.65A4.34,4.34,0,0,0,265.46,103.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.81,100.26a4.28,4.28,0,0,0-1.8-2.05c-.44.11-.89.24-1.33.38l0,.14a3.27,3.27,0,0,1,2.21,1.92,3.32,3.32,0,0,1-.09,2.64c.39-.12.79-.22,1.19-.32A4.33,4.33,0,0,0,272.81,100.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,99.85a4.3,4.3,0,0,0-.53-2.21c-.47-.08-.94-.15-1.4-.19a3.33,3.33,0,0,1,.91,2.36,3.29,3.29,0,0,1-1.43,2.56l.11.17c.36,0,.72.09,1.08.16A4.3,4.3,0,0,0,281.08,99.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41,104a4.2,4.2,0,0,0,.55-2.55c-.39-.31-.8-.61-1.22-.89a3.24,3.24,0,0,1-2.51,4.46c.34.25.68.52,1,.8A4.38,4.38,0,0,0,288.41,104Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,110.18a4.4,4.4,0,0,0,1.39-2c-.24-.49-.5-1-.79-1.47h0a3.26,3.26,0,0,1-4,3.27c.19.36.36.73.52,1.1l.22,0A4.42,4.42,0,0,0,293,110.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.61,117.56a4.37,4.37,0,0,0,2-1.25c-.07-.5-.14-1-.22-1.51a3.32,3.32,0,0,1-2.07,1.77,3.28,3.28,0,0,1-2.87-.56l0,0c.07.41.12.82.16,1.22a4.45,4.45,0,0,0,1.9.44A4.33,4.33,0,0,0,294.61,117.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,125.36a4.3,4.3,0,0,0,2.18-.62c.05-.44.08-.89.11-1.34a3.28,3.28,0,0,1-2.62.92,3.33,3.33,0,0,1-2.46-1.59c0,.48-.06,1-.11,1.46a4.43,4.43,0,0,0,2.46,1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.89,133.11a4.87,4.87,0,0,0,.76.06,4.74,4.74,0,0,0,1.82-.37c.08-.42.15-.85.22-1.28a3.74,3.74,0,0,1-2.63.58,3.84,3.84,0,0,1-2.4-1.52c-.07.44-.15.87-.22,1.31A4.87,4.87,0,0,0,292.89,133.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.68,141.34a4.71,4.71,0,0,0,2.58-.31c0-.25,0-.48.07-.73s0-.32.06-.48a3.7,3.7,0,0,1-2.54.51,3.83,3.83,0,0,1-2.47-1.61c0,.34-.1.67-.14,1l0,.38A5,5,0,0,0,291.68,141.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.62,149.24a4.68,4.68,0,0,0,2.63-.83c-.05-.4-.1-.8-.13-1.22a3.71,3.71,0,0,1-2.51,1h0a3.83,3.83,0,0,1-2.58-1.05c0,.46.06.92.11,1.37a4.78,4.78,0,0,0,2.47.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.86,157a4.83,4.83,0,0,0,2.38-1.63c-.18-.35-.36-.7-.52-1.07a3.68,3.68,0,0,1-2.14,1.71,3.86,3.86,0,0,1-2.79-.29c.17.44.34.87.54,1.3a5,5,0,0,0,1.22.16A4.82,4.82,0,0,0,293.86,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,160.49q-.46-.37-.9-.78a3.69,3.69,0,0,1-1.36,2.47,3.85,3.85,0,0,1-2.64.77c.34.34.69.67,1.06,1a4.83,4.83,0,0,0,2.21-1A4.71,4.71,0,0,0,300.45,160.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,166.88a4.8,4.8,0,0,0,.72-2.95q-.57-.18-1.11-.39a3.7,3.7,0,0,1-.47,2.79,3.79,3.79,0,0,1-2.27,1.6c.46.2.92.38,1.39.56A4.89,4.89,0,0,0,306.14,166.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.61,167.41a4.67,4.67,0,0,0-.92-2.4c-.49,0-1,0-1.47,0a3.67,3.67,0,0,1,1.37,2.53,3.85,3.85,0,0,1-.78,2.61c.37,0,.72,0,1.09,0H314A4.82,4.82,0,0,0,314.61,167.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.82,166.51a4.69,4.69,0,0,0-1.29-2.83l-1.17.34a3.7,3.7,0,0,1,1.44,2.58,3.82,3.82,0,0,1-.68,2.49c.45-.11.89-.21,1.34-.34A4.79,4.79,0,0,0,323.82,166.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.14,162.93a4.69,4.69,0,0,0-1.64-2.09c-.36.18-.71.37-1.07.54a3.73,3.73,0,0,1,1.76,1.93,3.8,3.8,0,0,1-.11,2.94l1.29-.62A4.78,4.78,0,0,0,331.14,162.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,159.2a4.79,4.79,0,0,0-2-2.33l-1.07.64a3.72,3.72,0,0,1,2.12,2.07,3.81,3.81,0,0,1,.05,2.58l1.19-.7A4.83,4.83,0,0,0,338.54,159.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,154.34a4.7,4.7,0,0,0-1.88-2.25l-.93.66a3.73,3.73,0,0,1,1.86,2,3.81,3.81,0,0,1-.18,3.1l1.39-1A4.88,4.88,0,0,0,345.69,154.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.45,150.27a4.69,4.69,0,0,0-1.86-2.24c-.34.2-.67.41-1,.63a3.74,3.74,0,0,1,1.91,2,3.83,3.83,0,0,1-.12,3c.44-.31.88-.61,1.34-.9A4.79,4.79,0,0,0,351.45,150.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Datas--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.43 274.14 65.44 277.89 127.07 242.31 127.06 238.56 65.43 274.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.43 280.73 65.44 284.48 105.14 261.56 105.12 257.81 65.43 280.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.43 274.14 65.44 277.89 127.07 242.31 127.06 238.56 65.43 274.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.43 280.73 65.44 284.48 105.14 261.56 105.12 257.81 65.43 280.73",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,205.91a6.48,6.48,0,0,0-1.68,1.45c-2,2.34-2.43,5.53-2.7,8.23q-.56,5.68-1.12,11.36a26.18,26.18,0,0,1-1.06,5.86,11.59,11.59,0,0,1-3.45,5.33,4.17,4.17,0,0,1-.6.4,3.44,3.44,0,0,1-3.83,0,10.14,10.14,0,0,1-2.52-3.54,8.72,8.72,0,0,0-3.38-3.83,5,5,0,0,0-4.7.39,8.28,8.28,0,0,0-.85.56c-3.19,2.45-5.07,7.27-6.54,11.44s-3.42,9-6.63,11.35a7.47,7.47,0,0,1-.67.43,5.41,5.41,0,0,1-6.31-.5c-1.77-1.36-3.19-3.34-5.4-3.9a5.38,5.38,0,0,0-3.45.49l0,18.22L142,225.47l-.09-30.29a25.7,25.7,0,0,0-3,8c-.66,3.64-.5,7.61-3,10.82a7.43,7.43,0,0,1-2.16,1.93,4.31,4.31,0,0,1-3.1.62c-1.52-.39-2.47-1.81-3.1-3.47-.85-2.22-1.22-5-2.57-6.6A3.57,3.57,0,0,0,120.32,205.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.32,205.91a6.48,6.48,0,0,0-1.68,1.45c-2,2.34-2.43,5.53-2.7,8.23q-.56,5.68-1.12,11.36a26.18,26.18,0,0,1-1.06,5.86,11.59,11.59,0,0,1-3.45,5.33,4.17,4.17,0,0,1-.6.4,3.44,3.44,0,0,1-3.83,0,10.14,10.14,0,0,1-2.52-3.54,8.72,8.72,0,0,0-3.38-3.83,5,5,0,0,0-4.7.39,8.28,8.28,0,0,0-.85.56c-3.19,2.45-5.07,7.27-6.54,11.44s-3.42,9-6.63,11.35a7.47,7.47,0,0,1-.67.43,5.41,5.41,0,0,1-6.31-.5c-1.77-1.36-3.19-3.34-5.4-3.9a5.38,5.38,0,0,0-3.45.49l0,18.22L142,225.47l-.09-30.29a25.7,25.7,0,0,0-3,8c-.66,3.64-.5,7.61-3,10.82a7.43,7.43,0,0,1-2.16,1.93,4.31,4.31,0,0,1-3.1.62c-1.52-.39-2.47-1.81-3.1-3.47-.85-2.22-1.22-5-2.57-6.6A3.57,3.57,0,0,0,120.32,205.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,155.59l69.15-39.93a2,2,0,0,1,1.82-.24h0l.05,0,.11.06,2.79,1.61a1.93,1.93,0,0,0-1.89.21L71.16,157.25a6,6,0,0,0-2.71,4.7l0,18.65a1.92,1.92,0,0,0,.79,1.74h0l-2.85-1.65h0l0,0h0a1.9,1.9,0,0,1-.76-1.72l-.06-18.64A6,6,0,0,1,68.29,155.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,180.6l0-18.65a6,6,0,0,1,2.71-4.7l69.16-39.93a1.93,1.93,0,0,1,1.89-.21l.07,0,0,0a1.92,1.92,0,0,1,.73,1.69l0,18.65a5.94,5.94,0,0,1-2.71,4.69L71.23,182.15a1.66,1.66,0,0,1-2.73-1.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,155.59l69.15-39.93a2,2,0,0,1,1.82-.24h0l.05,0,.11.06,2.79,1.61a1.93,1.93,0,0,0-1.89.21L71.16,157.25a5.94,5.94,0,0,0-2.4,3.08l-2.88-1.64A5.91,5.91,0,0,1,68.29,155.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.76,160.33a5,5,0,0,0-.31,1.62l0,18.65a1.92,1.92,0,0,0,.79,1.74h0l-2.85-1.65h0l0,0h0a1.9,1.9,0,0,1-.76-1.72l-.06-18.64a4.88,4.88,0,0,1,.31-1.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,118.88a1.92,1.92,0,0,0-.73-1.69l0,0-.07,0-2.79-1.61-.11-.06-.05,0h0a2,2,0,0,0-1.82.24L68.29,155.59a3.61,3.61,0,0,0-.69.51,1.07,1.07,0,0,0-.16.14,6.44,6.44,0,0,0-.55.61l0,.06a6.39,6.39,0,0,0-1,1.78h0a5.38,5.38,0,0,0-.21.76s0,0,0,.06a4.21,4.21,0,0,0-.08.78l.06,18.64a1.9,1.9,0,0,0,.76,1.72h0l0,0h0l2.85,1.65h0a1.91,1.91,0,0,0,1.94-.19l69.16-39.93a5.94,5.94,0,0,0,2.71-4.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.32 172.86 74.33 175.94 93.91 164.63 93.9 161.55 74.32 172.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.31 166.37 74.32 169.45 96.35 156.73 96.34 153.65 74.31 166.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.31 159.97 74.32 163.06 84.11 157.41 84.1 154.32 74.31 159.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,135.08a2.41,2.41,0,0,0-1.09,1.88V139c0,.69.5,1,1.1.63l1.81-1a2.37,2.37,0,0,0,1.08-1.88v-2.08c0-.69-.49-1-1.09-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56,127.11l-.27.17v2.5l.27-.17c3.47-2,6.31-.39,6.32,3.6a12.29,12.29,0,0,1-1.28,5.13l1.86.24a16.35,16.35,0,0,0,1.6-6.63C138.05,126.58,134.24,124.41,129.56,127.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,138l-.26.17v2.5l.27-.17c3.48-2,6.31-.4,6.32,3.6a12,12,0,0,1-1.28,5.13l1.86.24a16,16,0,0,0,1.6-6.63C119.2,137.47,115.38,135.3,110.7,138Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.56,127.11l-.27.17v2.5l.27-.17c3.47-2,6.31-.39,6.32,3.6a12.29,12.29,0,0,1-1.28,5.13l1.86.24a16.35,16.35,0,0,0,1.6-6.63C138.05,126.58,134.24,124.41,129.56,127.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,127.28c-4.55,2.8-8.19,9.2-8.18,14.46s3.83,7.55,8.51,4.85a18.14,18.14,0,0,0,6.85-8l-1.86-.24a13.41,13.41,0,0,1-5,5.75c-3.48,2-6.31.39-6.32-3.6a13.92,13.92,0,0,1,6-10.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.7,138l-.26.17v2.5l.27-.17c3.48-2,6.31-.4,6.32,3.6a12,12,0,0,1-1.28,5.13l1.86.24a16,16,0,0,0,1.6-6.63C119.2,137.47,115.38,135.3,110.7,138Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.4,196.87a4.16,4.16,0,0,0-1.89,3.26v3.61c0,1.2.85,1.69,1.9,1.08L70.56,203a4.16,4.16,0,0,0,1.88-3.26v-3.61c0-1.2-.85-1.68-1.89-1.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.43,207a4.16,4.16,0,0,0-1.89,3.26v3.61c0,1.2.85,1.68,1.9,1.08l3.14-1.82a4.14,4.14,0,0,0,1.88-3.25v-3.61c0-1.2-.85-1.68-1.89-1.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.45,217.21a4.17,4.17,0,0,0-1.88,3.26v3.6c0,1.21.85,1.69,1.9,1.08l3.14-1.81a4.12,4.12,0,0,0,1.87-3.26v-3.61c0-1.19-.85-1.67-1.88-1.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4,196.87a4.16,4.16,0,0,0-1.89,3.26v3.61c0,1.2.85,1.69,1.9,1.08L70.56,203a4.16,4.16,0,0,0,1.88-3.26v-3.61c0-1.2-.85-1.68-1.89-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.43,207a4.16,4.16,0,0,0-1.89,3.26v3.61c0,1.2.85,1.68,1.9,1.08l3.14-1.82a4.14,4.14,0,0,0,1.88-3.25v-3.61c0-1.2-.85-1.68-1.89-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.45,217.21a4.17,4.17,0,0,0-1.88,3.26v3.6c0,1.21.85,1.69,1.9,1.08l3.14-1.81a4.12,4.12,0,0,0,1.87-3.26v-3.61c0-1.19-.85-1.67-1.88-1.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.17 215.26 75.18 218.86 119.32 193.37 119.31 189.77 75.17 215.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.18 205.08 75.19 208.68 141.9 170.16 141.89 166.57 75.18 205.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.18 195.1 75.19 198.69 134.92 164.01 134.91 160.42 75.18 195.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,146a2.36,2.36,0,0,0-1.08,1.88v2.08c0,.69.49,1,1.09.62l1.81-1a2.39,2.39,0,0,0,1.09-1.89v-2.08c0-.69-.5-1-1.1-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,138.17c-4.55,2.79-8.2,9.19-8.18,14.46s3.82,7.55,8.5,4.85a18.13,18.13,0,0,0,6.85-8l-1.86-.24a13.4,13.4,0,0,1-5,5.75c-3.47,2-6.31.39-6.32-3.61a13.92,13.92,0,0,1,6-10.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.17 215.26 75.18 218.86 119.32 193.37 119.31 189.77 75.17 215.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.18 205.08 75.19 208.68 141.9 170.16 141.89 166.57 75.18 205.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.18 195.1 75.19 198.69 134.92 164.01 134.91 160.42 75.18 195.1",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.44,313.39,257.73,398.07a16,16,0,0,1-14.46,0L96.61,313.39c-2-1.15-3-2.67-3-4.19v23.05c0,1.52,1,3,3,4.2l146.66,84.67a15.92,15.92,0,0,0,14.46,0l145.71-84.68c2-1.15,3-2.67,3-4.18h0V309.2C406.42,310.72,405.43,312.23,403.44,313.39Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,313.39l146.66,84.68a16,16,0,0,0,14.46,0l145.71-84.68c2-1.16,3-2.67,3-4.19s-1-3-3-4.19L256.74,220.34a15.94,15.94,0,0,0-14.47,0L96.55,305c-2,1.16-3,2.68-3,4.19S94.6,312.24,96.61,313.39Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.13 316.96 249.59 252.56 138.86 316.91 250.4 381.31 361.13 316.96",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.13 316.96 249.59 252.56 138.86 316.91 250.4 381.31 361.13 316.96",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 309.2 138.86 316.91 249.59 252.56 249.59 237.09 125.51 309.2",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 237.09 249.59 252.56 361.13 316.96 374.48 309.2 249.59 237.09",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 309.2 138.86 316.91 249.59 252.56 249.59 237.09 125.51 309.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 237.09 249.59 252.56 361.13 316.96 374.48 309.2 249.59 237.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,398.07,96.61,313.39c-2-1.15-3-2.67-3-4.19v23.05c0,1.52,1,3,3,4.2l146.66,84.67a14.66,14.66,0,0,0,7.13,1.73V399.8A14.78,14.78,0,0,1,243.27,398.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,313.39,257.73,398.07a14.79,14.79,0,0,1-7.33,1.73v23.05a14.69,14.69,0,0,0,7.33-1.73l145.71-84.68c2-1.15,3-2.67,3-4.18h0V309.2C406.42,310.72,405.43,312.23,403.44,313.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 109.68 125.13 181.78 125.13 156.3 250.02 84.19 250.02 109.68",
    style: {
      fill: "#227EA1",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 160.65 125.13 232.75 125.13 207.27 250.02 135.16 250.02 160.65",
    style: {
      fill: "#227EA1",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 135.16 125.13 207.27 125.13 181.78 250.02 109.68 250.02 135.16",
    style: {
      fill: "#227EA1",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 186.13 125.13 258.24 125.13 232.75 250.02 160.65 250.02 186.13",
    style: {
      fill: "#227EA1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 211.61 125.13 283.72 125.13 258.24 250.02 186.13 250.02 211.61",
    style: {
      fill: "#227EA1",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 237.1 125.13 309.2 125.13 283.72 250.02 211.61 250.02 237.1",
    style: {
      fill: "#227EA1",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 84.19 125.13 156.3 125.13 130.82 250.02 58.71 250.02 84.19",
    style: {
      fill: "#227EA1",
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 12.09 250.02 33.23 125.13 105.33 125.13 84.19 250.02 12.09",
    style: {
      fill: "#227EA1",
      opacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.02 58.71 125.13 130.82 125.13 105.33 250.02 33.23 250.02 58.71",
    style: {
      fill: "#227EA1",
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 109.68 374.48 181.78 374.48 156.3 249.59 84.19 249.59 109.68",
    style: {
      fill: "#227EA1",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 160.65 374.48 232.75 374.48 207.27 249.59 135.16 249.59 160.65",
    style: {
      fill: "#227EA1",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 135.16 374.48 207.27 374.48 181.78 249.59 109.68 249.59 135.16",
    style: {
      fill: "#227EA1",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 186.13 374.48 258.24 374.48 232.75 249.59 160.65 249.59 186.13",
    style: {
      fill: "#227EA1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 211.61 374.48 283.72 374.48 258.24 249.59 186.13 249.59 211.61",
    style: {
      fill: "#227EA1",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 237.1 374.48 309.2 374.48 283.72 249.59 211.61 249.59 237.1",
    style: {
      fill: "#227EA1",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 84.19 374.48 156.3 374.48 130.82 249.59 58.71 249.59 84.19",
    style: {
      fill: "#227EA1",
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 12.09 249.59 33.23 374.48 105.33 374.48 84.19 249.59 12.09",
    style: {
      fill: "#227EA1",
      opacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.59 58.71 374.48 130.82 374.48 105.33 249.59 33.23 249.59 58.71",
    style: {
      fill: "#227EA1",
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "280.87 212.93 283.14 214.24 283.3 158.32 281.03 157.01 280.87 212.93",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.84 222.74 283.11 224.05 283.12 219.04 280.86 217.73 280.84 222.74",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.84 216.19 280.1 217.5 280.12 212.49 277.85 211.18 277.84 216.19",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.71 226.13 288.97 227.43 288.99 222.42 286.72 221.12 286.71 226.13",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.88 165.81 286.87 170.81 289.13 172.12 289.14 167.12 286.88 165.81",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.82 207.93 286.09 209.24 286.18 177.65 283.92 176.34 283.82 207.93",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.87 204.5 280.14 205.8 280.23 174.21 277.96 172.9 277.87 204.5",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.81 188.35 289.08 189.66 289.11 179.34 286.84 178.03 286.81 188.35",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.75 209.63 289.02 210.93 289.07 195.14 286.8 193.83 286.75 209.63",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.52 155.67 189.5 160.68 191.77 161.99 191.78 156.98 189.52 155.67",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.61 155.55 182.88 156.86 182.89 151.85 180.63 150.54 180.61 155.55",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.64 145.28 182.91 146.59 182.94 135 180.67 133.69 180.64 145.28",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.47 170.89 191.74 172.2 191.76 167.2 189.49 165.89 189.47 170.89",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.55 190.06 185.81 191.37 185.95 141.97 183.69 140.66 183.55 190.06",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.43 229.89 185.7 231.2 185.79 198.14 183.53 196.83 183.43 229.89",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.47 191.75 188.74 193.06 188.81 170.51 186.54 169.2 186.47 191.75",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.42 211.9 188.69 213.2 188.73 198.44 186.46 197.13 186.42 211.9",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.47 205.25 182.74 206.55 182.84 168.7 180.58 167.39 180.47 205.25",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.33 221.38 191.6 222.69 191.65 205.81 189.38 204.5 189.33 221.38",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.41 192.96 191.68 194.26 191.71 184.56 189.44 183.25 189.41 192.96",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.02 233.48 316.01 238.49 318.27 239.8 318.29 234.79 316.02 233.48",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.88 315.47 309.15 316.78 309.16 311.77 306.89 310.46 306.88 315.47",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.98 249.28 318.24 250.59 318.26 245.59 315.99 244.28 315.98 249.28",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.94 306.49 312.2 307.8 312.44 224.56 310.17 223.25 309.94 306.49",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.9 296.18 315.17 297.49 315.32 243.89 313.05 242.58 312.9 296.18",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.05 254.97 309.32 256.28 309.35 246.22 307.08 244.91 307.05 254.97",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.99 277.59 309.25 278.9 309.3 262.02 307.04 260.71 306.99 277.59",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.93 298.63 309.19 299.94 309.24 283.06 306.98 281.75 306.93 298.63",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.85 293.65 318.12 294.96 318.16 278.08 315.9 276.77 315.85 293.65",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.93 265.84 318.19 267.15 318.22 257.04 315.96 255.73 315.93 265.84",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.91 98.4 211.89 103.4 214.16 104.71 214.17 99.71 211.91 98.4",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.87 145.16 205.14 146.47 205.15 141.46 202.89 140.15 202.87 145.16",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.84 156.09 205.11 157.39 205.12 152.38 202.86 151.08 202.84 156.09",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.91 141.89 208.17 143.2 208.31 97.08 206.04 95.77 205.91 141.89",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.89 126.56 211.16 127.86 211.22 106.17 208.95 104.86 208.89 126.56",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.83 149.48 211.09 150.79 211.14 133.54 208.88 132.23 208.83 149.48",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.98 106.45 205.25 107.76 205.28 97.7 203.01 96.39 202.98 106.45",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.92 128.14 205.19 129.45 205.22 119.39 202.95 118.09 202.92 128.14",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.71 166.79 213.98 168.1 214.05 141.31 211.79 140 211.71 166.79",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.81 133.92 214.07 135.23 214.13 113.65 211.87 112.34 211.81 133.92",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "280.87 212.93 283.14 214.24 283.3 158.32 281.03 157.01 280.87 212.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.84 222.74 283.11 224.05 283.12 219.04 280.86 217.73 280.84 222.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.84 216.19 280.1 217.5 280.12 212.49 277.85 211.18 277.84 216.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.71 226.13 288.97 227.43 288.99 222.42 286.72 221.12 286.71 226.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.88 165.81 286.87 170.81 289.13 172.12 289.14 167.12 286.88 165.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.82 207.93 286.09 209.24 286.18 177.65 283.92 176.34 283.82 207.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.87 204.5 280.14 205.8 280.23 174.21 277.96 172.9 277.87 204.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.81 188.35 289.08 189.66 289.11 179.34 286.84 178.03 286.81 188.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.75 209.63 289.02 210.93 289.07 195.14 286.8 193.83 286.75 209.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.52 155.67 189.5 160.68 191.77 161.99 191.78 156.98 189.52 155.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.61 155.55 182.88 156.86 182.89 151.85 180.63 150.54 180.61 155.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.64 145.28 182.91 146.59 182.94 135 180.67 133.69 180.64 145.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.47 170.89 191.74 172.2 191.76 167.2 189.49 165.89 189.47 170.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.55 190.06 185.81 191.37 185.95 141.97 183.69 140.66 183.55 190.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.43 229.89 185.7 231.2 185.79 198.14 183.53 196.83 183.43 229.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.47 191.75 188.74 193.06 188.81 170.51 186.54 169.2 186.47 191.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.42 211.9 188.69 213.2 188.73 198.44 186.46 197.13 186.42 211.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.47 205.25 182.74 206.55 182.84 168.7 180.58 167.39 180.47 205.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.33 221.38 191.6 222.69 191.65 205.81 189.38 204.5 189.33 221.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.41 192.96 191.68 194.26 191.71 184.56 189.44 183.25 189.41 192.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.02 233.48 316.01 238.49 318.27 239.8 318.29 234.79 316.02 233.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.88 315.47 309.15 316.78 309.16 311.77 306.89 310.46 306.88 315.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.98 249.28 318.24 250.59 318.26 245.59 315.99 244.28 315.98 249.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.94 306.49 312.2 307.8 312.44 224.56 310.17 223.25 309.94 306.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.9 296.18 315.17 297.49 315.32 243.89 313.05 242.58 312.9 296.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.05 254.97 309.32 256.28 309.35 246.22 307.08 244.91 307.05 254.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.99 277.59 309.25 278.9 309.3 262.02 307.04 260.71 306.99 277.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.93 298.63 309.19 299.94 309.24 283.06 306.98 281.75 306.93 298.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.85 293.65 318.12 294.96 318.16 278.08 315.9 276.77 315.85 293.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.93 265.84 318.19 267.15 318.22 257.04 315.96 255.73 315.93 265.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.91 98.4 211.89 103.4 214.16 104.71 214.17 99.71 211.91 98.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.87 145.16 205.14 146.47 205.15 141.46 202.89 140.15 202.87 145.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.84 156.09 205.11 157.39 205.12 152.38 202.86 151.08 202.84 156.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.91 141.89 208.17 143.2 208.31 97.08 206.04 95.77 205.91 141.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.89 126.56 211.16 127.86 211.22 106.17 208.95 104.86 208.89 126.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.83 149.48 211.09 150.79 211.14 133.54 208.88 132.23 208.83 149.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.98 106.45 205.25 107.76 205.28 97.7 203.01 96.39 202.98 106.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.92 128.14 205.19 129.45 205.22 119.39 202.95 118.09 202.92 128.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.71 166.79 213.98 168.1 214.05 141.31 211.79 140 211.71 166.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.81 133.92 214.07 135.23 214.13 113.65 211.87 112.34 211.81 133.92",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,111.13l-.09,1.44a14.35,14.35,0,0,1-2.29,6.94h0a14.4,14.4,0,0,0-2.31,7.84V130a5.16,5.16,0,0,1-1.69,3.85c-6.68,6-15,3.19-9.68-2a2.23,2.23,0,0,0,.67-1.57v-3.82l11.72-15.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,113.66h0a6.45,6.45,0,0,0-5.14,4.76l-1.27,5a4.49,4.49,0,0,1-3.64,3.33l-5.84,1a4.42,4.42,0,0,1-4.85-2.72c-4.67-12-2.41-23.58,8.49-24.94,10.65-1.33,13.65,7.29,13.64,12A1.68,1.68,0,0,1,261,113.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38,113.48a.92.92,0,1,1-.87-1A.93.93,0,0,1,249.38,113.48Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69,112.76a.92.92,0,1,1-.87-1A.94.94,0,0,1,241.69,112.76Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6,178l-10.79-5.77-12.46,1.07v6l-.44,15.24c0,1.75,1.17,3.51,3.5,4.85,4.64,2.68,12.14,2.68,16.75,0,2.3-1.34,3.45-3.1,3.44-4.86h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,186.38a8.54,8.54,0,0,1-3.9-4.94,23.5,23.5,0,0,1-1-6.36,62.13,62.13,0,0,1,.48-14.36,28.16,28.16,0,0,1,3.16-9.06,10.43,10.43,0,0,1,6.86-5c11.09-2.41,21.12.68,27,4.76a7.41,7.41,0,0,1,3.16,5.77c.72,16.26-7.26,25.62-12,30.06-5,4.75-9.73-.46-11.53-4.84s-4.18-7.73-7.63-7.73-4.46,4.63-4.46,4.63Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,186.38a8.54,8.54,0,0,1-3.9-4.94,23.5,23.5,0,0,1-1-6.36,62.13,62.13,0,0,1,.48-14.36,28.16,28.16,0,0,1,3.16-9.06,10.43,10.43,0,0,1,6.86-5c11.09-2.41,21.12.68,27,4.76a7.41,7.41,0,0,1,3.16,5.77c.72,16.26-7.26,25.62-12,30.06-5,4.75-9.73-.46-11.53-4.84s-4.18-7.73-7.63-7.73-4.46,4.63-4.46,4.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,174.23c.8-2.34,1.49-4.71,2.17-7L260,167c-.63,2.19-1.28,4.42-2,6.62a18.94,18.94,0,0,0-3.73-3.81A25.57,25.57,0,0,0,238.89,165c-.37,0-.74,0-1.11,0a37.54,37.54,0,0,1,9.05-17.62l-.41-.38a38.1,38.1,0,0,0-9.21,18,33.33,33.33,0,0,0-10.07,2c0,.2,0,.4,0,.6a32.75,32.75,0,0,1,10-2,37.84,37.84,0,0,0-.68,9.2,2.45,2.45,0,0,1,.39,0H237a37.73,37.73,0,0,1,.7-9.18c.4,0,.81,0,1.21,0a25.06,25.06,0,0,1,15.05,4.77,18.27,18.27,0,0,1,3.84,4,52.42,52.42,0,0,1-2.35,5.82,30.11,30.11,0,0,1-5.89,8.45,5.38,5.38,0,0,0,.55.24,30.81,30.81,0,0,0,5.84-8.45,51.34,51.34,0,0,0,2.24-5.49,16.58,16.58,0,0,1,2.58,7.06l.47-.66A17.23,17.23,0,0,0,258.39,174.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,146a9.82,9.82,0,0,0-7.62,1.61c-6.61,5.57,2.08,8.79,9,2.6a5.1,5.1,0,0,0,1.06-1.35C252.29,148,252.13,146.35,249.45,146Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.36,156.78c-.51-2.31-1.77-3.66-3.32-3.9a6.56,6.56,0,0,1,1,2.36A14.71,14.71,0,0,1,261,168a5,5,0,0,1-4.07,1.59c1.46,2,4,2.16,6.4-.06A14.71,14.71,0,0,0,267.36,156.78Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.36,156.78c-.51-2.31-1.77-3.66-3.32-3.9a6.56,6.56,0,0,1,1,2.36A14.71,14.71,0,0,1,261,168a5,5,0,0,1-4.07,1.59c1.46,2,4,2.16,6.4-.06A14.71,14.71,0,0,0,267.36,156.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,168A14.71,14.71,0,0,0,265,155.24a6.56,6.56,0,0,0-1-2.36,5.07,5.07,0,0,0-4.08,1.59,14.74,14.74,0,0,0-4,12.74,6.62,6.62,0,0,0,1,2.37A5,5,0,0,0,261,168Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,187.49a1.1,1.1,0,0,0,1.11-.72c0-.05,1.91-4.9,6.33-6.84a1.12,1.12,0,1,0-.89-2.05c-5.3,2.33-7.44,7.87-7.53,8.1a1.13,1.13,0,0,0,.65,1.44A1,1,0,0,0,143.22,187.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,187.31a1.12,1.12,0,0,0,1-.77,13.26,13.26,0,0,1,5.82-6.7,1.12,1.12,0,0,0-1-2,15.33,15.33,0,0,0-6.9,8,1.11,1.11,0,0,0,.7,1.41A1.24,1.24,0,0,0,147.12,187.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83,186.39a1.12,1.12,0,0,0,.86-.79,16.58,16.58,0,0,1,5.15-7.37,1.12,1.12,0,0,0-1.39-1.75,18.61,18.61,0,0,0-5.91,8.5,1.12,1.12,0,0,0,.76,1.38A1.07,1.07,0,0,0,151.83,186.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.49,
    cy: 177.95,
    r: 6.46,
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.49,
    cy: 177.95,
    r: 6.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,179.63a4,4,0,0,0,2.75-1.07,136.9,136.9,0,0,1,36.41-23.69,4.09,4.09,0,1,0-3.31-7.49A145.39,145.39,0,0,0,154,172.51a4.09,4.09,0,0,0,2.76,7.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.89,
    cy: 149.66,
    r: 10.55,
    transform: "translate(-27.67 46.3) rotate(-12.48)",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.89,
    cy: 149.66,
    r: 10.55,
    transform: "translate(-27.67 46.3) rotate(-12.48)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,156.75a12.61,12.61,0,0,0,2.42-11.95,11.51,11.51,0,0,0-3.36-4.81,10.63,10.63,0,0,0-2.18-.68,11.29,11.29,0,0,1,4.84,5.74,11.81,11.81,0,0,1-2.29,11.22,15.15,15.15,0,0,1-5.16,3.91c.2,0,.39,0,.59,0,.36,0,.72,0,1.07-.05A15.5,15.5,0,0,0,203,156.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.11,154.93a3.84,3.84,0,0,1-.61-1.43,9,9,0,0,1,2.46-7.73,3.31,3.31,0,0,1,2.15-1h-2.26a3.23,3.23,0,0,0-2.18,1,8.93,8.93,0,0,0-2.46,7.73,4,4,0,0,0,.6,1.43,2.11,2.11,0,0,0,1.64.95h2.33A2.09,2.09,0,0,1,203.11,154.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,147.17c-.32-1.4-1.07-2.21-2-2.36a1.67,1.67,0,0,0-.32,0,3.31,3.31,0,0,0-2.15,1,9,9,0,0,0-2.46,7.73,3.84,3.84,0,0,0,.61,1.43,2.09,2.09,0,0,0,1.67.95,3.22,3.22,0,0,0,2.21-1A9,9,0,0,0,209.45,147.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,180.36a1.11,1.11,0,0,0-1.53,0,12.14,12.14,0,0,0-3.49,7.11,1.12,1.12,0,0,0,2.22.27A9.92,9.92,0,0,1,153,182a1.11,1.11,0,0,0,0-1.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.48,192.89a3.89,3.89,0,0,1-.61-1.44,8.9,8.9,0,0,1,2.46-7.72,3.3,3.3,0,0,1,2.14-1h-2.25a3.25,3.25,0,0,0-2.18,1,8.9,8.9,0,0,0-2.46,7.72,4.06,4.06,0,0,0,.6,1.44,2.11,2.11,0,0,0,1.64.94h2.33A2.08,2.08,0,0,1,289.48,192.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.81,185.13c-.31-1.4-1.07-2.22-2-2.36a1.84,1.84,0,0,0-.33,0,3.3,3.3,0,0,0-2.14,1,8.9,8.9,0,0,0-2.46,7.72,3.89,3.89,0,0,0,.61,1.44,2.08,2.08,0,0,0,1.67,1,3.27,3.27,0,0,0,2.2-1A8.93,8.93,0,0,0,295.81,185.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.17,
    cy: 189.89,
    r: 10.55,
    transform: "translate(46.65 438.67) rotate(-76.78)",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.17,
    cy: 189.89,
    r: 10.55,
    transform: "translate(46.65 438.67) rotate(-76.78)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.15,198.07a11.17,11.17,0,0,0,1-18,11.15,11.15,0,0,0-2.16-.61,10.46,10.46,0,0,1-7.21,19.43,10.71,10.71,0,0,0,2.06.95h.11A11.3,11.3,0,0,0,303.15,198.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,219.85a4.08,4.08,0,0,1-2.75-1.06A136.81,136.81,0,0,0,304,195.09a4.09,4.09,0,1,1,3.31-7.48,144.9,144.9,0,0,1,38.61,25.13,4.09,4.09,0,0,1-2.76,7.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 218.18,
    r: 6.46,
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 218.18,
    r: 6.46,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.84,229.62a1.11,1.11,0,0,1-1.07-.78c0-.05-1.61-5-5.9-7.21a1.12,1.12,0,1,1,1-2c5.14,2.64,6.94,8.3,7,8.54a1.11,1.11,0,0,1-.74,1.39A1,1,0,0,1,351.84,229.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,227.63a1.1,1.1,0,0,1-1.05-.74,13.2,13.2,0,0,0-5.92-6.63,1.11,1.11,0,0,1,1-2,15.32,15.32,0,0,1,7,7.87,1.12,1.12,0,0,1-.69,1.42A1.15,1.15,0,0,1,355.07,227.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,224.8a1.11,1.11,0,0,1-1-.59,16.56,16.56,0,0,0-6.52-6.21,1.11,1.11,0,1,1,1-2,18.56,18.56,0,0,1,7.48,7.15,1.13,1.13,0,0,1-.47,1.51A1.2,1.2,0,0,1,357.65,224.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,228.57a1.11,1.11,0,0,1-1.11-1,12.15,12.15,0,0,1,2.14-7.62,1.12,1.12,0,0,1,1.84,1.27,9.91,9.91,0,0,0-1.75,6.22,1.13,1.13,0,0,1-1.05,1.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.74,130.65h0a7.27,7.27,0,0,0-5.8,5.37l-1.43,5.61a5.07,5.07,0,0,1-4.1,3.75l-6.59,1.07a5,5,0,0,1-5.46-3.07c-5.27-13.55-2.71-26.58,9.56-28.11,12-1.5,15.4,8.22,15.39,13.51A1.9,1.9,0,0,1,230.74,130.65Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.74,130.65h0a7.27,7.27,0,0,0-5.8,5.37l-1.43,5.61a5.07,5.07,0,0,1-4.1,3.75l-6.59,1.07a5,5,0,0,1-5.46-3.07c-5.27-13.55-2.71-26.58,9.56-28.11,12-1.5,15.4,8.22,15.39,13.51A1.9,1.9,0,0,1,230.74,130.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,119.83a10.6,10.6,0,0,1,4.47,1.76,15.67,15.67,0,0,0-.82-1.35,11.62,11.62,0,0,0-4.44-1.25,13.59,13.59,0,0,0-4.78-3,13.38,13.38,0,0,0-2.56-.66l.55-.15c-.5,0-1,.06-1.54.13a15.86,15.86,0,0,0-3.34.78c.37-.06.74-.11,1.12-.14a14.49,14.49,0,0,0-3.38,2.81,18,18,0,0,0-3.85,7.52,12.7,12.7,0,0,1-2-1c-.06.25-.13.5-.18.76a13.45,13.45,0,0,0,2,1c-.08.38-.16.77-.23,1.17a32.58,32.58,0,0,0,.16,10.34,21.13,21.13,0,0,0,1.39,5.25,11.83,11.83,0,0,0,1.39,2.36,5,5,0,0,0,1.32.37,9.93,9.93,0,0,1-2-3,20.65,20.65,0,0,1-1.34-5.07,31.65,31.65,0,0,1-.15-10.1c.06-.35.13-.7.2-1a13.89,13.89,0,0,0,3.79.66h.09a3.24,3.24,0,0,0,3-1.94,10.81,10.81,0,0,1,6.38-5.74,10.28,10.28,0,0,1,3.7-.48,12.42,12.42,0,0,1,1.76,2.24,14.38,14.38,0,0,1,1.78,9.51,7.33,7.33,0,0,1,.8-.38,15,15,0,0,0-1.95-9.52A13.86,13.86,0,0,0,226,119.83Zm-5-.33a11.52,11.52,0,0,0-6.83,6.14,2.53,2.53,0,0,1-2.35,1.5,13.19,13.19,0,0,1-3.64-.64,17.33,17.33,0,0,1,3.71-7.29,13.19,13.19,0,0,1,4.48-3.33,12.73,12.73,0,0,1,3.85.77,12.58,12.58,0,0,1,3.91,2.32A10.38,10.38,0,0,0,221,119.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,137a6.29,6.29,0,0,0,4.86-4.26c.21-.65.4-1.32.56-2a1.24,1.24,0,0,0-1.32-1.51,64,64,0,0,1-9,.2,21.39,21.39,0,0,1-4.57-.62,9.58,9.58,0,0,1-3.25-1.56,26.91,26.91,0,0,0,.23,8.68,11.35,11.35,0,0,0,5.37,1.49A30.16,30.16,0,0,0,217.71,137Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.24,218.56c-1.62,25.11-.13,56.39-.13,56.39l9.18,2.34a212.9,212.9,0,0,0,7.47-40.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,314.85l-3.91-36.91a4.6,4.6,0,0,0-1.49-2.93l-2-1.85-6.51.58-3.91,40.09,1.07-1.43a2.23,2.23,0,0,1,2.31-.82l.61.16a5.39,5.39,0,0,1,3.39,2.56l1.78,3.08a2.92,2.92,0,0,0,3.59,1.26l.11-.05a11.37,11.37,0,0,0,4.41-3.08Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,314.85l-3.91-36.91a4.6,4.6,0,0,0-1.49-2.93l-2-1.85-6.51.58-3.91,40.09,1.07-1.43a2.23,2.23,0,0,1,2.31-.82l.61.16a5.39,5.39,0,0,1,3.39,2.56l1.78,3.08a2.92,2.92,0,0,0,3.59,1.26l.11-.05a11.37,11.37,0,0,0,4.41-3.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18,319.67a10.86,10.86,0,0,1-5,1.9l-1.41.15a10.83,10.83,0,0,0-4.37,1.46l-2.46,1.46a15.29,15.29,0,0,1-14.23.75l-.86-.4a1.77,1.77,0,0,1-1-1.61v1.4a1.78,1.78,0,0,0,1,1.62l.86.39a15.32,15.32,0,0,0,14.23-.74l2.46-1.47a10.82,10.82,0,0,1,4.37-1.45l1.41-.16a11,11,0,0,0,5-1.89,2,2,0,0,0,.84-1.81l-.07-.73A2,2,0,0,1,241.18,319.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.81,325l.86.4a15.29,15.29,0,0,0,14.23-.75l2.46-1.46a10.83,10.83,0,0,1,4.37-1.46l1.41-.15a10.86,10.86,0,0,0,5-1.9,2,2,0,0,0,.77-1.13l-.29-3a11.37,11.37,0,0,1-4.41,3.08l-.11.05a2.92,2.92,0,0,1-3.59-1.26l-1.78-3.08a5.39,5.39,0,0,0-3.39-2.56l-.61-.16a2.23,2.23,0,0,0-2.31.82l-1.07,1.43-2.73,1.69a45.11,45.11,0,0,1-7.95,3.91,3,3,0,0,0-1.93,2.79v1.16A1.77,1.77,0,0,0,212.81,325Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.8,310.61a1.72,1.72,0,0,1-1.42-.27,1.77,1.77,0,0,1-.75-1.28l-2-21.83a1.89,1.89,0,0,1,1.39-2,9.76,9.76,0,0,0,3.84-2.23l-.08-.71a9.09,9.09,0,0,1-3.92,2.4,2.46,2.46,0,0,0-1.79,2.58l2,21.83a2.31,2.31,0,0,0,1,1.69,2.28,2.28,0,0,0,1.88.35,12.09,12.09,0,0,0,3.74-1.68l-.07-.64A11.39,11.39,0,0,1,237.8,310.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,275.27c-.26,3.34-2.45,5.9-4.89,5.7s-4.19-3.06-3.93-6.4,2.46-5.9,4.89-5.71S236.06,271.92,235.79,275.27Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,324.89a8.56,8.56,0,0,1-.17-1.13,1.11,1.11,0,0,0-1-1,8,8,0,0,1-4.58-2.11,2.93,2.93,0,0,0-.48,1.61v1.16a1.77,1.77,0,0,0,1,1.61l.86.4a15.38,15.38,0,0,0,8.54,1.25,13.52,13.52,0,0,1-3.15-.62A1.55,1.55,0,0,1,218,324.89Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,324.89a8.56,8.56,0,0,1-.17-1.13,1.11,1.11,0,0,0-1-1,8,8,0,0,1-4.58-2.11,2.93,2.93,0,0,0-.48,1.61v1.16a1.77,1.77,0,0,0,1,1.61l.86.4a15.38,15.38,0,0,0,8.54,1.25,13.52,13.52,0,0,1-3.15-.62A1.55,1.55,0,0,1,218,324.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,275.27c-.26,3.34-2.45,5.9-4.89,5.7s-4.19-3.06-3.93-6.4,2.46-5.9,4.89-5.71S236.06,271.92,235.79,275.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.11,214.56c0,8.31,1.57,24.88,16.93,25.14,10.08.18,14.78-5.29,16.82-9.07a11.22,11.22,0,0,0,1.26-6.25,38.75,38.75,0,0,0-2.76-11.89Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.11,214.56c0,8.31,1.57,24.88,16.93,25.14,10.08.18,14.78-5.29,16.82-9.07a11.22,11.22,0,0,0,1.26-6.25,38.75,38.75,0,0,0-2.76-11.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,207.94c6.4,3.69,6.43,9.69.07,13.38s-16.7,3.7-23.11,0-6.44-9.69-.07-13.38S249.57,204.24,256,207.94Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,207.94c6.4,3.69,6.43,9.69.07,13.38s-16.7,3.7-23.11,0-6.44-9.69-.07-13.38S249.57,204.24,256,207.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.42,218.74a22.51,22.51,0,0,0,20.13,0,7.62,7.62,0,0,0,2.83-2.6,7.67,7.67,0,0,0-2.9-2.66,22.56,22.56,0,0,0-20.13,0,7.54,7.54,0,0,0-2.83,2.6A7.65,7.65,0,0,0,234.42,218.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.35,213.49a22.56,22.56,0,0,1,20.13,0,7.67,7.67,0,0,1,2.9,2.66,3.06,3.06,0,0,0,.43-1.49c0-1.41-1.21-2.92-3.33-4.15a20.91,20.91,0,0,0-10.08-2.37,20.59,20.59,0,0,0-10.05,2.37c-2.08,1.21-3.27,2.7-3.26,4.09a3.06,3.06,0,0,0,.43,1.49A7.54,7.54,0,0,1,234.35,213.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.42,218.74a22.51,22.51,0,0,0,20.13,0,7.62,7.62,0,0,0,2.83-2.6,7.67,7.67,0,0,0-2.9-2.66,22.56,22.56,0,0,0-20.13,0,7.54,7.54,0,0,0-2.83,2.6A7.65,7.65,0,0,0,234.42,218.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,275.11c1.27-14.15.59-40.65-.76-46.52-2.75-9.91-18.28-1.63-17.47,5.63s3.75,27.06,9.18,42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,275,254.78,276a4.47,4.47,0,0,0-2.21,3.86c0,6.57.15,25,1.12,46.71l1.21-1.78a6.91,6.91,0,0,0,.74-1.46l.76-2.14a2.48,2.48,0,0,1,2.33-1.64h1.59a2.48,2.48,0,0,1,2.37,1.75l1,3.33a6.6,6.6,0,0,0,.93,1.88l.49.68a2.37,2.37,0,0,0,3.78.11l2.34-2.92a1.63,1.63,0,0,0,.34-1.28l-6.83-44.77a4.49,4.49,0,0,0-1.43-2.65l-.64-.57Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,275,254.78,276a4.47,4.47,0,0,0-2.21,3.86c0,6.57.15,25,1.12,46.71l1.21-1.78a6.91,6.91,0,0,0,.74-1.46l.76-2.14a2.48,2.48,0,0,1,2.33-1.64h1.59a2.48,2.48,0,0,1,2.37,1.75l1,3.33a6.6,6.6,0,0,0,.93,1.88l.49.68a2.37,2.37,0,0,0,3.78.11l2.34-2.92a1.63,1.63,0,0,0,.34-1.28l-6.83-44.77a4.49,4.49,0,0,0-1.43-2.65l-.64-.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,339.59l1.65.47a19,19,0,0,0,7.39.58l3-.35a7.54,7.54,0,0,0,6.65-7.49V332a4.46,4.46,0,0,1,1.36-3.21l.8-.78a2.34,2.34,0,0,0,.65-1.18l-.16-2-2,2.55a2.37,2.37,0,0,1-3.78-.11l-.49-.68a6.6,6.6,0,0,1-.93-1.88l-1-3.33a2.48,2.48,0,0,0-2.37-1.75h-1.59a2.48,2.48,0,0,0-2.33,1.64l-.76,2.14a6.91,6.91,0,0,1-.74,1.46l-6.54,9.63a4,4,0,0,0-.7,2.25V337A2.69,2.69,0,0,0,249.61,339.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.45,328l-.8.78a4.46,4.46,0,0,0-1.36,3.21v.84a7.54,7.54,0,0,1-6.65,7.49l-3,.35a19,19,0,0,1-7.39-.58l-1.65-.47a2.69,2.69,0,0,1-2-2.58v1.63a2.69,2.69,0,0,0,2,2.58l1.65.46a19,19,0,0,0,7.39.59l3-.36a7.51,7.51,0,0,0,6-4.45h0a7.52,7.52,0,0,0,.64-3v-.85a4.46,4.46,0,0,1,1.36-3.21l.8-.77a2.43,2.43,0,0,0,.72-1.93l-.07-.88A2.34,2.34,0,0,1,270.45,328Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,338.21c-.12-.46-.23-.94-.32-1.41a1.84,1.84,0,0,0-1.39-1.43,24.09,24.09,0,0,0-6.93-.58,1.79,1.79,0,0,0-1.67,1.43,9.64,9.64,0,0,0-.15,2.21,2.71,2.71,0,0,0,1.53,1.16l1.65.47a19,19,0,0,0,7.39.58l3-.35h0a9.83,9.83,0,0,1-1.21-.19A2.6,2.6,0,0,1,258.54,338.21Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,338.21c-.12-.46-.23-.94-.32-1.41a1.84,1.84,0,0,0-1.39-1.43,24.09,24.09,0,0,0-6.93-.58,1.79,1.79,0,0,0-1.67,1.43,9.64,9.64,0,0,0-.15,2.21,2.71,2.71,0,0,0,1.53,1.16l1.65.47a19,19,0,0,0,7.39.58l3-.35h0a9.83,9.83,0,0,1-1.21-.19A2.6,2.6,0,0,1,258.54,338.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.91,291.3a240.65,240.65,0,0,0,3.94,25.78,2.78,2.78,0,0,0,2.72,2.15,2.07,2.07,0,0,0,.35,0,12.74,12.74,0,0,0,2-.41l-.08-.56a12.38,12.38,0,0,1-2,.42,2.22,2.22,0,0,1-2.46-1.7,236.43,236.43,0,0,1-3.93-25.7,3.76,3.76,0,0,1,1.4-3.28,24.76,24.76,0,0,1,2.11-1.54l-.09-.6a26.5,26.5,0,0,0-2.38,1.71A4.37,4.37,0,0,0,261.91,291.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.92,317.45a237.49,237.49,0,0,0-.7-26.06A4.29,4.29,0,0,0,253,288l-.35-.19v.63l.08,0a3.82,3.82,0,0,1,2,3,241.51,241.51,0,0,1,.7,26,2.22,2.22,0,0,1-2,2.09c0,.19,0,.37,0,.56A2.77,2.77,0,0,0,255.92,317.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,276.77c.36,3.33-1.53,6.27-4.22,6.56s-5.16-2.18-5.52-5.51,1.53-6.28,4.22-6.57S262.88,273.43,263.24,276.77Z",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,276.77c.36,3.33-1.53,6.27-4.22,6.56s-5.16-2.18-5.52-5.51,1.53-6.28,4.22-6.57S262.88,273.43,263.24,276.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.55 252.01 251.81 253.32 251.97 197.4 249.71 196.09 249.55 252.01",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.52 261.82 251.78 263.13 251.8 258.12 249.53 256.81 249.52 261.82",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.51 255.27 248.78 256.58 248.79 251.57 246.53 250.26 246.51 255.27",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.38 265.2 257.65 266.51 257.67 261.5 255.4 260.2 255.38 265.2",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.56 204.89 255.54 209.89 257.81 211.2 257.82 206.2 255.56 204.89",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.5 247.01 254.77 248.32 254.86 216.73 252.59 215.42 252.5 247.01",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.54 243.58 248.81 244.88 248.9 213.29 246.63 211.98 246.54 243.58",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.49 227.44 257.76 228.74 257.79 218.42 255.52 217.11 255.49 227.44",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.43 248.71 257.7 250.01 257.74 234.22 255.47 232.91 255.43 248.71",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.29 269.05 223.28 274.06 225.54 275.37 225.56 270.36 223.29 269.05",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.38 268.93 216.65 270.24 216.67 265.23 214.4 263.92 214.38 268.93",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.41 258.66 216.68 259.97 216.71 248.38 214.45 247.07 214.41 258.66",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.25 284.27 225.51 285.58 225.53 280.58 223.26 279.27 223.25 284.27",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.32 303.44 219.59 304.74 219.72 255.34 217.46 254.03 217.32 303.44",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.21 343.27 219.47 344.58 219.57 311.52 217.3 310.21 217.21 343.27",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.25 305.13 222.51 306.44 222.58 283.88 220.31 282.58 220.25 305.13",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.19 325.27 222.46 326.58 222.5 311.82 220.23 310.51 220.19 325.27",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.24 318.62 216.51 319.93 216.62 282.08 214.35 280.77 214.24 318.62",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.1 334.76 225.37 336.07 225.42 319.18 223.15 317.88 223.1 334.76",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.19 306.33 225.45 307.64 225.48 297.94 223.21 296.63 223.19 306.33",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.38 288.8 282.37 293.8 284.63 295.11 284.65 290.1 282.38 288.8",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.24 370.79 275.51 372.1 275.52 367.09 273.25 365.78 273.24 370.79",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.33 304.59 284.6 305.9 284.62 300.9 282.35 299.59 282.33 304.59",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.3 361.81 278.56 363.12 278.8 279.87 276.53 278.56 276.3 361.81",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.26 351.5 281.53 352.81 281.68 299.2 279.41 297.89 279.26 351.5",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.41 310.28 275.68 311.59 275.71 301.54 273.44 300.23 273.41 310.28",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.35 332.91 275.62 334.21 275.66 317.33 273.4 316.02 273.35 332.91",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.29 353.95 275.56 355.26 275.6 338.37 273.34 337.06 273.29 353.95",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.21 348.97 284.48 350.28 284.52 333.39 282.26 332.08 282.21 348.97",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.29 321.16 284.55 322.46 284.58 312.35 282.32 311.04 282.29 321.16",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.78 209.29 173.77 214.29 176.04 215.6 176.05 210.6 173.78 209.29",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.75 256.05 167.02 257.36 167.03 252.35 164.76 251.04 164.75 256.05",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.72 266.98 166.99 268.29 167 263.28 164.73 261.97 164.72 266.98",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.78 252.78 170.05 254.09 170.18 207.97 167.92 206.66 167.78 252.78",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.77 237.45 173.04 238.76 173.1 217.06 170.83 215.75 170.77 237.45",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.7 260.38 172.97 261.69 173.02 244.43 170.75 243.12 170.7 260.38",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.86 217.34 167.13 218.65 167.16 208.59 164.89 207.29 164.86 217.34",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.8 239.03 167.07 240.34 167.09 230.29 164.83 228.98 164.8 239.03",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 277.69 175.86 279 175.93 252.2 173.67 250.89 173.59 277.69",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.68 244.81 175.95 246.12 176.01 224.54 173.74 223.23 173.68 244.81",
    style: {
      fill: "#227EA1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.55 252.01 251.81 253.32 251.97 197.4 249.71 196.09 249.55 252.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.52 261.82 251.78 263.13 251.8 258.12 249.53 256.81 249.52 261.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.51 255.27 248.78 256.58 248.79 251.57 246.53 250.26 246.51 255.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.38 265.2 257.65 266.51 257.67 261.5 255.4 260.2 255.38 265.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.56 204.89 255.54 209.89 257.81 211.2 257.82 206.2 255.56 204.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.5 247.01 254.77 248.32 254.86 216.73 252.59 215.42 252.5 247.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.54 243.58 248.81 244.88 248.9 213.29 246.63 211.98 246.54 243.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.49 227.44 257.76 228.74 257.79 218.42 255.52 217.11 255.49 227.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.43 248.71 257.7 250.01 257.74 234.22 255.47 232.91 255.43 248.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.29 269.05 223.28 274.06 225.54 275.37 225.56 270.36 223.29 269.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.38 268.93 216.65 270.24 216.67 265.23 214.4 263.92 214.38 268.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.41 258.66 216.68 259.97 216.71 248.38 214.45 247.07 214.41 258.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.25 284.27 225.51 285.58 225.53 280.58 223.26 279.27 223.25 284.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.32 303.44 219.59 304.74 219.72 255.34 217.46 254.03 217.32 303.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.21 343.27 219.47 344.58 219.57 311.52 217.3 310.21 217.21 343.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.25 305.13 222.51 306.44 222.58 283.88 220.31 282.58 220.25 305.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.19 325.27 222.46 326.58 222.5 311.82 220.23 310.51 220.19 325.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.24 318.62 216.51 319.93 216.62 282.08 214.35 280.77 214.24 318.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.1 334.76 225.37 336.07 225.42 319.18 223.15 317.88 223.1 334.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.19 306.33 225.45 307.64 225.48 297.94 223.21 296.63 223.19 306.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.38 288.8 282.37 293.8 284.63 295.11 284.65 290.1 282.38 288.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.24 370.79 275.51 372.1 275.52 367.09 273.25 365.78 273.24 370.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.33 304.59 284.6 305.9 284.62 300.9 282.35 299.59 282.33 304.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.3 361.81 278.56 363.12 278.8 279.87 276.53 278.56 276.3 361.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.26 351.5 281.53 352.81 281.68 299.2 279.41 297.89 279.26 351.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.41 310.28 275.68 311.59 275.71 301.54 273.44 300.23 273.41 310.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.35 332.91 275.62 334.21 275.66 317.33 273.4 316.02 273.35 332.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.29 353.95 275.56 355.26 275.6 338.37 273.34 337.06 273.29 353.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.21 348.97 284.48 350.28 284.52 333.39 282.26 332.08 282.21 348.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.29 321.16 284.55 322.46 284.58 312.35 282.32 311.04 282.29 321.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.78 209.29 173.77 214.29 176.04 215.6 176.05 210.6 173.78 209.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.75 256.05 167.02 257.36 167.03 252.35 164.76 251.04 164.75 256.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.72 266.98 166.99 268.29 167 263.28 164.73 261.97 164.72 266.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.78 252.78 170.05 254.09 170.18 207.97 167.92 206.66 167.78 252.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.77 237.45 173.04 238.76 173.1 217.06 170.83 215.75 170.77 237.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.7 260.38 172.97 261.69 173.02 244.43 170.75 243.12 170.7 260.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.86 217.34 167.13 218.65 167.16 208.59 164.89 207.29 164.86 217.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.8 239.03 167.07 240.34 167.09 230.29 164.83 228.98 164.8 239.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.59 277.69 175.86 279 175.93 252.2 173.67 250.89 173.59 277.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.68 244.81 175.95 246.12 176.01 224.54 173.74 223.23 173.68 244.81",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 181.78 250.4 253.89 250.4 228.41 125.51 156.3 125.51 181.78",
    style: {
      fill: "#227EA1",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 232.75 250.4 304.86 250.4 279.37 125.51 207.27 125.51 232.75",
    style: {
      fill: "#227EA1",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 207.27 250.4 279.37 250.4 253.89 125.51 181.78 125.51 207.27",
    style: {
      fill: "#227EA1",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 258.23 250.4 330.34 250.4 304.86 125.51 232.75 125.51 258.23",
    style: {
      fill: "#227EA1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 283.72 250.4 355.82 250.4 330.34 125.51 258.23 125.51 283.72",
    style: {
      fill: "#227EA1",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 309.2 250.4 381.31 250.4 355.82 125.51 283.72 125.51 309.2",
    style: {
      fill: "#227EA1",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 156.3 250.4 228.41 250.4 202.92 125.51 130.82 125.51 156.3",
    style: {
      fill: "#227EA1",
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 30.59 125.51 105.33 250.4 177.44 250.4 102.7 125.51 30.59",
    style: {
      fill: "#227EA1",
      opacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.51 130.82 250.4 202.92 250.4 177.44 125.51 105.33 125.51 130.82",
    style: {
      fill: "#227EA1",
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 181.78 250.4 253.89 250.4 228.41 375.29 156.3 375.29 181.78",
    style: {
      fill: "#227EA1",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 232.75 250.4 304.86 250.4 279.37 375.29 207.27 375.29 232.75",
    style: {
      fill: "#227EA1",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 207.27 250.4 279.37 250.4 253.89 375.29 181.78 375.29 207.27",
    style: {
      fill: "#227EA1",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 258.23 250.4 330.34 250.4 304.86 375.29 232.75 375.29 258.23",
    style: {
      fill: "#227EA1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 283.72 250.4 355.82 250.4 330.34 375.29 258.23 375.29 283.72",
    style: {
      fill: "#227EA1",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 309.2 250.4 381.31 250.4 355.82 375.29 283.72 375.29 309.2",
    style: {
      fill: "#227EA1",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 156.3 250.4 228.41 250.4 202.92 375.29 130.82 375.29 156.3",
    style: {
      fill: "#227EA1",
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 30.59 375.29 105.33 250.4 177.44 250.4 102.7 375.29 30.59",
    style: {
      fill: "#227EA1",
      opacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.29 130.82 250.4 202.92 250.4 177.44 375.29 105.33 375.29 130.82",
    style: {
      fill: "#227EA1",
      opacity: 0.03
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.56,317.39l-4.17-8.68h0c-4.68-9.75-8.82-20.77-17.06-18.2l8.8,23.6,1.78,3.75-4.25,4.67.31,11.15,13.69-11.88A3.71,3.71,0,0,0,392.56,317.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.35,321.2a8.63,8.63,0,0,1-2.45-3.34L380.84,319A5.5,5.5,0,0,0,384.35,321.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.52,319.38l-2.87,3.15.31,11.15,2.59-2.24A78.31,78.31,0,0,1,380.52,319.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.35,298.85a16.29,16.29,0,0,0-6.29-1l6.06,16.27,1.22,2.57A29.05,29.05,0,0,0,380.35,298.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.67,281.39h0A4.4,4.4,0,0,0,351,283.5L348,288.88l-9.62,11a26,26,0,0,0-5.82,11.48h0a5.34,5.34,0,0,0,1.39,4.91h0a5.35,5.35,0,0,0,7.59.09l3.21-3.15-.7-4.94L352.43,292l4.6-2.69a3.77,3.77,0,0,0,1.81-2.64l.36-2.13Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.56,432.14a4.38,4.38,0,0,1-4,2.67,19.6,19.6,0,0,1-5-.64c-3.74-.68-7.34,0-11.07-.09a15.93,15.93,0,0,1-3.64-.4,6,6,0,0,1-3.11-1.83,4.05,4.05,0,0,1-.89-2,3.81,3.81,0,0,0,.89,3,6,6,0,0,0,3.11,1.83,15.39,15.39,0,0,0,3.64.4c3.73.09,7.33-.58,11.07.09a19.62,19.62,0,0,0,5,.65,4.41,4.41,0,0,0,4-2.68,4.15,4.15,0,0,0,.13-1.72A2.83,2.83,0,0,1,358.56,432.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,429l-.69-3.39a5,5,0,0,0-.58-1.73,1.68,1.68,0,0,0-1.51-.86c-2-.28-4.92-1-6.62.15a15.21,15.21,0,0,1-9.15,2.66,31.78,31.78,0,0,0-5.06-.2,4.53,4.53,0,0,0-3.93,2.75,3.22,3.22,0,0,0-.08,1.48,4.05,4.05,0,0,0,.89,2,6,6,0,0,0,3.11,1.83,15.93,15.93,0,0,0,3.64.4c3.73.09,7.33-.59,11.07.09a19.6,19.6,0,0,0,5,.64,4.38,4.38,0,0,0,4-2.67,2.83,2.83,0,0,0,.13-.63A8,8,0,0,0,358.47,429Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.56,432.14a4.38,4.38,0,0,1-4,2.67,19.6,19.6,0,0,1-5-.64c-3.74-.68-7.34,0-11.07-.09a15.93,15.93,0,0,1-3.64-.4,6,6,0,0,1-3.11-1.83,4.05,4.05,0,0,1-.89-2,3.81,3.81,0,0,0,.89,3,6,6,0,0,0,3.11,1.83,15.39,15.39,0,0,0,3.64.4c3.73.09,7.33-.58,11.07.09a19.62,19.62,0,0,0,5,.65,4.41,4.41,0,0,0,4-2.68,4.15,4.15,0,0,0,.13-1.72A2.83,2.83,0,0,1,358.56,432.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,429l-.69-3.39a5,5,0,0,0-.58-1.73,1.68,1.68,0,0,0-1.51-.86c-2-.28-4.92-1-6.62.15a15.21,15.21,0,0,1-9.15,2.66,31.78,31.78,0,0,0-5.06-.2,4.53,4.53,0,0,0-3.93,2.75,3.22,3.22,0,0,0-.08,1.48,4.05,4.05,0,0,0,.89,2,6,6,0,0,0,3.11,1.83,15.93,15.93,0,0,0,3.64.4c3.73.09,7.33-.59,11.07.09a19.6,19.6,0,0,0,5,.64,4.38,4.38,0,0,0,4-2.67,2.83,2.83,0,0,0,.13-.63A8,8,0,0,0,358.47,429Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.57,419.66l-.14,4.42a1.75,1.75,0,0,0,1.62,1.81,28.81,28.81,0,0,0,4.46,0,2.53,2.53,0,0,0,2.28-2.37l.17-3.27Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.45,417.31a3.42,3.42,0,0,1-.59,1.82,3.33,3.33,0,0,1-2.09,1.18,5.27,5.27,0,0,1-5.18-2.14c-.56-.8-.87-1.75-1.4-2.57a11.82,11.82,0,0,0-2.9-2.83,12.19,12.19,0,0,1-2.93-2.8,4.13,4.13,0,0,1-.56-3.74,2.73,2.73,0,0,0-.27.47,4.23,4.23,0,0,0,.52,4,12.45,12.45,0,0,0,3,2.89,11.87,11.87,0,0,1,3,2.91c.54.85.86,1.83,1.43,2.66a5.34,5.34,0,0,0,5.28,2.2,3.41,3.41,0,0,0,2.13-1.21,4.07,4.07,0,0,0,.62-2.54C377.46,417.49,377.45,417.4,377.45,417.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.11,411.75c-1.35-2.35-4.12-4.07-6.26-5.74a8.09,8.09,0,0,0-4.14-1.88,3.88,3.88,0,0,0-3.86,2s0,.09-.05.13a4.13,4.13,0,0,0,.56,3.74,12.19,12.19,0,0,0,2.93,2.8,11.82,11.82,0,0,1,2.9,2.83c.53.82.84,1.77,1.4,2.57a5.27,5.27,0,0,0,5.18,2.14,3.33,3.33,0,0,0,2.09-1.18,3.42,3.42,0,0,0,.59-1.82c0-.22,0-.43,0-.64A10.38,10.38,0,0,0,376.11,411.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.45,417.31a3.42,3.42,0,0,1-.59,1.82,3.33,3.33,0,0,1-2.09,1.18,5.27,5.27,0,0,1-5.18-2.14c-.56-.8-.87-1.75-1.4-2.57a11.82,11.82,0,0,0-2.9-2.83,12.19,12.19,0,0,1-2.93-2.8,4.13,4.13,0,0,1-.56-3.74,2.73,2.73,0,0,0-.27.47,4.23,4.23,0,0,0,.52,4,12.45,12.45,0,0,0,3,2.89,11.87,11.87,0,0,1,3,2.91c.54.85.86,1.83,1.43,2.66a5.34,5.34,0,0,0,5.28,2.2,3.41,3.41,0,0,0,2.13-1.21,4.07,4.07,0,0,0,.62-2.54C377.46,417.49,377.45,417.4,377.45,417.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.11,411.75c-1.35-2.35-4.12-4.07-6.26-5.74a8.09,8.09,0,0,0-4.14-1.88,3.88,3.88,0,0,0-3.86,2s0,.09-.05.13a4.13,4.13,0,0,0,.56,3.74,12.19,12.19,0,0,0,2.93,2.8,11.82,11.82,0,0,1,2.9,2.83c.53.82.84,1.77,1.4,2.57a5.27,5.27,0,0,0,5.18,2.14,3.33,3.33,0,0,0,2.09-1.18,3.42,3.42,0,0,0,.59-1.82c0-.22,0-.43,0-.64A10.38,10.38,0,0,0,376.11,411.75Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,409.71v4a6.74,6.74,0,0,0,6.25-.28l.38-3.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,336.79c1.21,3.62-.27,20.8-1,37.28,2.62,6.23,1.91,23.91.41,36.47,0,0-2.62,1.61-7.34,0l-5.93-34.66-.82-19.6s-1.49,17.38-3.2,28.54c1.61,8.54,1.21,10.15-2.76,36.42a9.93,9.93,0,0,1-8.89,0c-2.25-36.91-1.42-70.55-1-82.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,336.79l-30.51,1.81c-.14,4.11-.33,10.71-.43,19.09a31.76,31.76,0,0,0,15.84,3.39c.28-2.92.44-4.8.44-4.8l.2,4.75a31.77,31.77,0,0,0,14.4-4.66C378.41,346.82,378.73,339.08,378,336.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.8,368.21l-.67-16c4.13,0,8-3.08,10.88-6a18.46,18.46,0,0,1-8.23,7.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,350.38c-.28-4.21-2.17-22.34-1.86-26.63.62-8.7,1.92-16.79,1.76-21-.23-6.33-1-13.46-10.82-12l-10.44,1-5.3,1.29-7.36,15.28v19l-1,27.33a38.1,38.1,0,0,0,21.41,2.65,80,80,0,0,0,2.3-14c1,4.47,1,8.87,1.12,13.22C376.33,354.85,380.08,352.09,380.84,350.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.82,312.31l7.55-8.3a36,36,0,0,1-7.55,15.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,270.22a1.49,1.49,0,0,1-.21-1.64,1.91,1.91,0,0,1-1.56-.21A1.47,1.47,0,0,1,352,267a1.22,1.22,0,0,1,1-1.06,2.08,2.08,0,0,1-1.57-2.2,2.54,2.54,0,0,1,1.75-1.94,6.08,6.08,0,0,1,2.72-.14,2.18,2.18,0,0,1,1.14-2.58,2.64,2.64,0,0,1,2.5.41,7.62,7.62,0,0,1,1.77,1.94,8,8,0,0,1,6.52-.41,8.12,8.12,0,0,1,4.55,4.73,5.37,5.37,0,0,1,3.46,3.61,8.51,8.51,0,0,1-.3,5.06A23,23,0,0,1,373.2,279l-1.3,2.07c-.55.86-1.95,3-2.5,3.88a8.13,8.13,0,0,1-7.72-.48,13.11,13.11,0,0,1-4.95-6.15A42.89,42.89,0,0,1,354.47,270.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.08,285.86a8.54,8.54,0,0,1-4.46-1.26,13.19,13.19,0,0,1-5-6.21,42.42,42.42,0,0,1-2.26-8.11,1.47,1.47,0,0,1-.3-1.51,2.09,2.09,0,0,1-1.42-.29,1.57,1.57,0,0,1-.74-1.46,1.37,1.37,0,0,1,.71-1,2.33,2.33,0,0,1-.86-.73,2.09,2.09,0,0,1-.41-1.49,2.63,2.63,0,0,1,1.84-2,6,6,0,0,1,2.58-.18A2.34,2.34,0,0,1,357,259a2.79,2.79,0,0,1,2.63.42,7.54,7.54,0,0,1,1.73,1.89,8.09,8.09,0,0,1,6.53-.37,8.2,8.2,0,0,1,4.59,4.75,5.44,5.44,0,0,1,3.49,3.67,8.66,8.66,0,0,1-.3,5.14,23,23,0,0,1-2.38,4.59l-1.3,2.07-1.29,2L369.51,285l0,0h0A7.49,7.49,0,0,1,366.08,285.86Zm-11.57-17.5-.14.28a1.35,1.35,0,0,0,.19,1.48l0,0v0a41.76,41.76,0,0,0,2.25,8.1,13.06,13.06,0,0,0,4.9,6.09,8,8,0,0,0,7.56.49c.27-.43.73-1.14,1.2-1.86l1.28-2,1.3-2.07a22.84,22.84,0,0,0,2.36-4.54,8.39,8.39,0,0,0,.29-5,5.2,5.2,0,0,0-3.37-3.51l-.06,0,0-.07a7.94,7.94,0,0,0-4.47-4.65,7.82,7.82,0,0,0-6.41.41l-.1.05-.06-.09a8,8,0,0,0-1.74-1.92,2.55,2.55,0,0,0-2.38-.39,2.07,2.07,0,0,0-1.07,2.41l.07.2-.21,0a6.17,6.17,0,0,0-2.66.14,2.43,2.43,0,0,0-1.66,1.84,1.82,1.82,0,0,0,.35,1.29,1.84,1.84,0,0,0,1.11.76l.94.14-.95.12a1.07,1.07,0,0,0-.89.94,1.3,1.3,0,0,0,.62,1.21,1.71,1.71,0,0,0,1.44.2Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.28,275.58l-1.65,2.87,1.63.6A33.47,33.47,0,0,1,353.28,275.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,270.22a23.41,23.41,0,0,0-1.19,5.36,33.47,33.47,0,0,0,0,3.47,32.94,32.94,0,0,0,.57,4.84,5.08,5.08,0,0,0,.95,2.43,3.83,3.83,0,0,0,2.64,1.22,11.4,11.4,0,0,0,3-.29V292c3.57.84,6.52,1.21,9.32-.94l-.3-6a8.76,8.76,0,0,1-5-.8c-2.46-1.33-3.15-3.45-2.81-4.64a1.86,1.86,0,0,0,1.93.68,2.6,2.6,0,0,0,1.6-1.27,5.39,5.39,0,0,0,.6-2,3.69,3.69,0,0,0-.37-2.48,2.6,2.6,0,0,0-2.79-.94,4,4,0,0,0-2.35,2,6.07,6.07,0,0,0-.41.9.56.56,0,0,1-1.08-.13,7.43,7.43,0,0,1,.7-3.94,2.75,2.75,0,0,1-1.31.31,1.66,1.66,0,0,1-1.26-.59,1.1,1.1,0,0,1-.05-1.33A2.21,2.21,0,0,1,354.47,270.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.85,294.53a7.65,7.65,0,0,0-8-2.87c-3.38,4.25-8.62,8.93-11.05,14.42a16.22,16.22,0,0,0-1.43,4.69,7.87,7.87,0,0,0,.8,4.77,6.32,6.32,0,0,0,5.35,3.19c2.18,0,4.61-2.26,6.29-3.67-.27-6.7-2.25-8.92-2.25-8.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.85,294.53a7.13,7.13,0,0,0-1.81-1.74,13,13,0,0,0-4.45,2.54,35.53,35.53,0,0,0-4.42,4.83c-1.73,2.13-3.27,4.32-5,6.45l7.37,5.29c-.63-4.26-2-5.76-2-5.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.18,306.61l9.89-9.74a14,14,0,0,1,8.14-3.9l.17,0c4.19,9.18-1.35,13.66-1.35,13.66l-9.2,8.45A16.6,16.6,0,0,1,336.18,306.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.29,418.57a24,24,0,0,0,10.94,6.22c1.18.31,2.58.67,3,1.82a2.78,2.78,0,0,1-1.23,3,7.46,7.46,0,0,1-5.26,1.19,23.58,23.58,0,0,1-5.31-1.49,19.44,19.44,0,0,0-5.33-1.36,24.86,24.86,0,0,1-2.6-.15,3.18,3.18,0,0,1-2.19-1.28c0-5.31,1.38-7.2,1.38-7.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,416.22v3.59c-2.42,2.64-6.25.88-6.71-.51l-.12-3.08Z",
    style: {
      fill: "#bd7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.37,403.35c4.3-3.88,6.68-3.73,7.71-3s2.9,3.26-1.86,7.45-4.4,6.79-7.72,6.79-2.69-3.32-2.69-3.32a14.51,14.51,0,0,1,.52-3.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,405.83v2.54c-2,1.74-5.41.75-5.59-.44l.16-2.51Z",
    style: {
      fill: "#bd7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,335.32l1.86,44.11-5,36.79c-2.69,1.73-6.83,0-6.83,0-.56-11.32-3-27.37-1.07-36l-3.73-23.72-1.24,19.06c-.21,11.18-3.11,23.09-3.63,30.23a6.2,6.2,0,0,1-5.43-.41c-1.68-14.88-5-22.88-1.82-33.52-2.21-20-4.1-32.44-1.32-37.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,335.32l1.86,44.11-5,36.79c-2.69,1.73-6.83,0-6.83,0-.56-11.32-3-27.37-1.07-36l-3.73-23.72-1.24,19.06c-.21,11.18-3.11,23.09-3.63,30.23a6.2,6.2,0,0,1-5.43-.41c-1.68-14.88-5-22.88-1.82-33.52-2.21-20-4.1-32.44-1.32-37.52Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,352l.71,4.51-.39,6L129,353.13a8.6,8.6,0,0,1-6.16-3.94A16,16,0,0,0,130.08,352Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,360.57a21.06,21.06,0,0,0,3.31-.82l-1-24.43-28.25-.94c-2,3.64-1.58,11.08-.37,22.37a24.22,24.22,0,0,0,7.34,3,41.59,41.59,0,0,0,6.2.93l.27-4.16.66,4.23c1.25.08,2.5.13,3.75.16A42.38,42.38,0,0,0,143.32,360.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36,327.62c0-.67-.08-1.33-.13-2v0h0c-.55-8.74-1.34-16.51-1.34-16.51L137,294l-13-1.74c-5.45-.52-7.79,5.45-7.71,11,0,3.25,1.74,11.5,2.78,20-4.94,10.43-4.63,23.7-4.53,28.83a31.69,31.69,0,0,0,7.25,3.83,52,52,0,0,1,1.07-11.06,67.09,67.09,0,0,0,1.22,11.84c10.13,3.08,20.9,1.63,24.49-1.55C148.59,355.12,147.06,338.63,146.36,327.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,277.55a10.13,10.13,0,0,0,1.14-5.32,5.74,5.74,0,0,0-2.79-4.5,4.07,4.07,0,0,0-5,.87,9.29,9.29,0,0,0-13.71,8.89c.13,1.91.83,3.79.61,5.7-.12,1.12-.57,2.25-.27,3.34a3.41,3.41,0,0,0,1.82,2.05c.83.44,2.78.33,3.71.52,2.81,2.56,6.35,1.6,8.6-.69S141.27,277.55,141.27,277.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.86 280.09 143.62 283.15 141.69 283.86 141.86 280.09",
    style: {
      fill: "#a85353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,278.73c-.28-2.69-1.07-5.22-2.82-6.5a14.43,14.43,0,0,1-2,9.6,4.2,4.2,0,0,0-1.3-2.3,2.42,2.42,0,0,0-2.5-.53,2.44,2.44,0,0,0-1.25,1.37,3.25,3.25,0,0,0,4.07,4.3,6.26,6.26,0,0,1-4.81,4.87,8,8,0,0,1-4.66-.44l-.73,3.61c2.94,3.14,8,1,8,1l.66-3.55c5.79.34,6.33.24,7-2.95A31.37,31.37,0,0,0,142.06,278.73Z",
    style: {
      fill: "#bd7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,274.83a10.18,10.18,0,0,0-4.61-5.5,9.72,9.72,0,0,0-3.72,8.16c.13,1.91.83,3.79.61,5.7-.12,1.12-.57,2.25-.27,3.34a3.41,3.41,0,0,0,1.82,2.05c.83.44,2.78.33,3.71.52.12.11.41.09.53.19a27.57,27.57,0,0,0,2.13-5.77A15.12,15.12,0,0,0,129.24,274.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63,272.82a7.38,7.38,0,0,0-14.06-.17c-1.75,5.28,2.73,10.9,1.75,16.38-.35,2-1.4,3.77-1.75,5.75a8.51,8.51,0,0,0,7.34,10,5,5,0,0,1-.56-5.26,23.42,23.42,0,0,1,3.09-4.66C127.88,288.74,129.82,280,127.63,272.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,315.42a43.18,43.18,0,0,0,5,5.94c-.5-6.86-1.05-12.27-1.05-12.27l-5.76-11a15.73,15.73,0,0,0-2.28,4.56C135.52,307,138.34,311.68,140.91,315.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.24 283.56 171.1 310.05 152.21 299.56 161.25 273.37 180.24 283.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.24 283.56 171.1 310.05 152.21 299.56 161.25 273.37 180.24 283.56",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.24 283.56 171.1 310.05 152.21 299.56 161.25 273.37 180.24 283.56",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.01 298.49 162.54 276.68 177.43 284.66 169.82 306.7 155.01 298.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.16 278.3 173.44 282.64 173.79 281.53 172.19 280.12 167.66 277.84 165.59 277.46 165.16 278.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.66 277.84 168.01 277 172.44 279.38 172.19 280.12 167.66 277.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.45 275.62 175.45 280.99 175.88 279.95 165.79 274.65 165.45 275.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,275.89c.87-2.75,6.1-.16,5.08,2.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,304.93l7,9.07L170,302.07a4.25,4.25,0,0,0,1.23-2.48c.58-4.53,1.83-7.75,3.44-7.19,1,.36-.29,4.77-.29,4.77l1.52-.87,1.76-5.1h.79a2,2,0,0,1,1.91,1.35l.75,2.18a6.41,6.41,0,0,1-2.24,7.25l-2.66,2a4.11,4.11,0,0,0-1,1.07,133.1,133.1,0,0,1-14.22,18.18,3.64,3.64,0,0,1-4.59.47c-7.42-4.91-13.55-13.2-13.55-13.2Z",
    style: {
      fill: "#bd7070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,305.06l-7.46,7.2-9.74-12.47a14.68,14.68,0,0,0-9.89-5.64L137,294s-2.38,10,2.73,15.54l9.75,10.32c3.57,3.83,6.47,6.09,9.24,5.7s4.3-2,7.16-5.7,8-10.15,8-10.15C172.46,304.85,168,304.34,165.3,305.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,310.23l-2.1,2,3.45,3.88C161.7,314,160.66,311.58,159.94,310.23Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.c477a2d5381bae26dce99628cf6b8c27.svg";
export { ForwardRef as ReactComponent };